<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'devices'}">Devices</router-link>
          </li>
          <li class="active">
            <a href="#">Edit Device</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content device-content">
        <div class="box" v-loading="loading">
          <div class="box-body">
            <el-form
              :model="device"
              :rules="rules"
              ref="device"
              label-width="120px"
              label-position="top"
            >
              <el-row :gutter="20">
                <el-col :md="24" :lg="8">
                  <el-form-item label="Name" prop="name">
                    <el-input v-model="device.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="24" :lg="8">
                  <el-form-item label="Serial" prop="serial">
                    <el-input v-model="device.serial"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="24" :lg="8">
                  <el-form-item label="ICC Id" prop="iccId">
                    <el-input v-model="device.iccId"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <hr>
              <el-form-item label="channels" prop="channels">
                <template slot="label">
                  channels
                  <el-button type="success" @click="addChannel" icon="el-icon-plus" size="mini">Add</el-button>
                </template>
                <el-table :data="device.channels" style="width: 100%">
                  <template slot="empty">Loading...</template>
                  <el-table-column label="Name" prop="name">
                    <template scope="scope">
                      <el-form-item
                        :inline-message="true"
                        :prop="`channels.${scope.$index}.name`"
                        :rules="{required: true, message: 'Please input device channel name', trigger: 'blur'}"
                      >
                        <el-input v-model="device.channels[scope.$index].name"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="Channel" prop="channelIndex">
                    <template scope="scope">
                      <el-form-item
                        :prop="`channels.${scope.$index}.channelIndex`"
                        :rules="{type:'number',required: true, message: 'Please input device channel index', trigger: 'blur'}"
                      >
                        <el-input-number
                          :min="0"
                          :max="10"
                          v-model="device.channels[scope.$index].channelIndex"
                        ></el-input-number>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column align="right">
                    <template scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-minus"
                        @click="handleRemove(scope.$index)"
                        :disabled="device.channels.length<=1"
                      >Remove</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('device')">Save</el-button>
                <el-button @click="resetForm('device')">Reset</el-button>
              </el-form-item>
            </el-form>
            <hr>
          </div>
          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import { required, minLength, between } from 'vuelidate/lib/validators'
export default {
  name: "device-edit",
  props: {
    serial: {
      // type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      device: {
        serial: "",
        name: "",
        iccId: "",
        channels: [
          {
            name: "",
            channelIndex: 0
          }
        ]
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please input device name",
            trigger: "blur"
          },
          { min: 3, message: "Length should be more then 3", trigger: "blur" }
        ],
        serial: [
          {
            required: true,
            message: "Please input device serial",
            trigger: "blur"
          },
          { min: 4, message: "Length should be more then 4", trigger: "blur" }
        ],
        iccId: [
          {
            required: true,
            message: "Please input device ICC Id",
            trigger: "blur"
          },
          { min: 6, message: "Length should be more then 6", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    ...mapGetters("devices", ["list"])
  },
  mounted() {
    this.loading = true;
    this.getDevice(this.serial)
      .then(resp => {
        this.loading = false;
        this.device = resp.data;
      })
      .catch(_ => {
        this.loading = false;
        this.$router.push({ name: "404" });
      });
  },
  methods: {
    ...mapActions("devices", ["saveDevice", "getDevice"]),
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          // eslint-disable-next-line camelcase
          const { serial, name, iccId, channels } = this.device;
          this.saveDevice({
            serial: this.serial,
            device: { serial, name, iccId, channels }
          })
            .then(_ => this.$router.push({ name: "devices" }))
            .catch(ex => {
              this.loading = false;
              this.$message({
                type: "error",
                message: ex.response.data.error
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addChannel() {
      this.device.channels.push({
        name: "",
        channelIndex: 0
      });
    },
    handleRemove(index) {
      if (this.device.channels.length > 1) {
        this.device.channels.splice(index, 1);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Edit.vue?7d26a7e2